import React from 'react';

interface Props {
	file: string;
}

class ResponsiveButton extends React.Component<Props> {
	public audio?: HTMLAudioElement;

	public componentDidMount() {
		this.audio = new Audio(this.props.file);
		this.audio.volume = 0.1;
		this.audio?.play().catch(() => null);
	}

	public componentWillUnmount() {
		if (this.audio) {
			this.audio.pause();
			this.audio.currentTime = 0;
		}
	}

	public render() {
		return null;
	}
}

export default ResponsiveButton;
